import {
    SET_SITE_CARDS,
    SET_SITE_CARDS_VISIBLE,
    SET_SITE_CARDS_FILTERS,
    FETCH_SITE_CARDS_REQUEST,
    FETCH_SITE_CARDS_SUCCESS,
    FETCH_SITE_CARDS_FAILURE,
    CREATE_SITE_CARD_REQUEST,
    CREATE_SITE_CARD_SUCCESS,
    CREATE_SITE_CARD_FAILURE,
    CREATE_SITE_CARDS_REQUEST,
    CREATE_SITE_CARDS_SUCCESS,
    CREATE_SITE_CARDS_FAILURE,
    UPDATE_SITE_CARD_REQUEST,
    UPDATE_SITE_CARD_SUCCESS,
    UPDATE_SITE_CARD_FAILURE,
    DELETE_SITE_CARD_REQUEST,
    DELETE_SITE_CARD_SUCCESS,
    DELETE_SITE_CARD_FAILURE,
    EXPORT_SITE_CARD_REQUEST,
    EXPORT_SITE_CARD_SUCCESS,
    EXPORT_SITE_CARD_FAILURE,
    IExportSiteCardRequestAction
} from './Types';

import axios, { Canceler } from 'axios';
import { openSnackbar } from '../ui/Actions';
import { SiteCard } from './siteCardTypes';
import { Filters } from '../../utility/Types/commonTypes';
import { Dispatch } from 'redux';
import { snakeCase } from 'lodash';

const host = process.env.HOST;
// const host = 'http:localhost:3000'

const CancelToken = axios.CancelToken;
let cancelFetchSiteCards: Canceler,
    cancelCreateSiteCard: Canceler,
    cancelCreateSiteCardFromFeatureAnalysis: Canceler,
    cancelCreateSiteCardsFromFeatureAnalyses: Canceler,
    cancelUpdateSiteCard: Canceler,
    cancelDeleteSiteCard: Canceler;

export const setSiteCards = (siteCards: SiteCard[]) => ({
    type: SET_SITE_CARDS,
    siteCards
});
export const setSiteCardsVisible = (visible: boolean) => ({
    type: SET_SITE_CARDS_VISIBLE,
    visible
});
export const setSiteCardsFilters = (filters: Filters) => ({
    type: SET_SITE_CARDS_FILTERS,
    filters
});
//
const fetchSiteCards = () => ({ type: FETCH_SITE_CARDS_REQUEST });
const fetchSiteCardsSuccess = (siteCards: SiteCard[]) => ({
    type: FETCH_SITE_CARDS_SUCCESS,
    siteCards
});
const fetchSiteCardsError = (error: any) => ({
    type: FETCH_SITE_CARDS_FAILURE,
    error
});
//
const createSiteCard = () => ({ type: CREATE_SITE_CARD_REQUEST });
const createSiteCardSuccess = (siteCard: SiteCard) => ({
    type: CREATE_SITE_CARD_SUCCESS,
    siteCard
});
const createSiteCardError = (error: any) => ({
    type: CREATE_SITE_CARD_FAILURE,
    error
});
const createSiteCards = () => ({ type: CREATE_SITE_CARDS_REQUEST });
const createSiteCardsSuccess = (siteCards: SiteCard[]) => ({
    type: CREATE_SITE_CARDS_SUCCESS,
    siteCards
});
const createSiteCardsError = (error: any) => ({
    type: CREATE_SITE_CARDS_FAILURE,
    error
});
//
const updateSiteCard = (id: number, name?: string, description?: string) => ({
    type: UPDATE_SITE_CARD_REQUEST,
    id,
    name,
    description
});
const updateSiteCardSuccess = (id: number, siteCard: SiteCard) => ({
    type: UPDATE_SITE_CARD_SUCCESS,
    id,
    siteCard
});
const updateSiteCardError = (id: number, error?: any) => ({
    type: UPDATE_SITE_CARD_FAILURE,
    id,
    error
});
//
const deleteSiteCard = (id: number) => ({ type: DELETE_SITE_CARD_REQUEST, id });
const deleteSiteCardSuccess = (id: number) => ({
    type: DELETE_SITE_CARD_SUCCESS,
    id
});
const deleteSiteCardError = (id: number, error?: any) => ({
    type: DELETE_SITE_CARD_FAILURE,
    id,
    error
});

const exportSiteCardRequest = (): IExportSiteCardRequestAction => ({
    type: EXPORT_SITE_CARD_REQUEST
});

const exportSiteCardSucess = (): IExportSiteCardRequestAction => ({
    type: EXPORT_SITE_CARD_SUCCESS
});

const exportSiteCardError = (error: any): IExportSiteCardRequestAction => ({
    type: EXPORT_SITE_CARD_FAILURE,
    error
});

// Fetch a lite version of all site cards async
// TODO add additional parameters to limit selection to ids
export const fetchSiteCardsAsync = (projectId: number) => {
    cancelFetchSiteCards && cancelFetchSiteCards();
    return async (dispatch: Dispatch) => {
        dispatch(fetchSiteCards());
        try {
            const response = await axios.get(`/api/projects/${projectId}/site_cards`, {
                cancelToken: new CancelToken(c => {
                    cancelFetchSiteCards = c;
                })
            });
            dispatch(fetchSiteCardsSuccess(response.data));
        } catch (error) {
            console.error(error);
            dispatch(fetchSiteCardsError(error.response));
        }
    };
};


// Create sitecard from feature analysis
// export const createSiteCardAsync = (layerId, featureId, name, description, weightingProfileId) => {
export const createSiteCardAsync = (
    projectId: number,
    name: string,
    columnId: number | null,
    params: any
) => {
    cancelCreateSiteCard && cancelCreateSiteCard();
    return async (dispatch: Dispatch) => {
        dispatch(createSiteCard());
        try {
            const response = await axios.post(
                `/api/projects/${projectId}/site_cards`,
                {
                    name: name,
                    column_id: columnId,
                    ...({ description: params.description } || {}),
                    ...({ layer_id: params.layerId } || {}),
                    ...({ feature_id: params.featureId } || {}),
                    ...({ feature_ids: params.featureIds } || {}),
                    ...({ is_drawn: params.isDrawn } || {}),
                    ...({ weighting_profile_id: params.weightingProfileId } || {}),
                    ...({ geometry: params.geometry } || {}),
                    ...({ buffer: params.buffer } || {})
                },
                {
                    cancelToken: new CancelToken(c => {
                        cancelCreateSiteCard = c;
                    })
                }
            );
            dispatch(createSiteCardSuccess(response.data));
            dispatch(openSnackbar('success', 'Successfully created site card'));
        } catch (error) {
            // Redirect to the sites page if there is a 404 error
            console.error(error);
            dispatch(openSnackbar('error', 'Error creating site card'));
            dispatch(createSiteCardError(error.response));
        }
    };
};

// Create sitecard from feature analysis
export const createSiteCardFromFeatureAnalysisAsync = (
    featureAnalysisId: number,
    name: string,
    columnId: number | null,
    params: any
) => {
    cancelCreateSiteCardFromFeatureAnalysis && cancelCreateSiteCardFromFeatureAnalysis();
    return async (dispatch: Dispatch) => {
        dispatch(createSiteCard());
        try {
            const response = await axios.put(
                `/api/feature_analyses/${featureAnalysisId}/site_card`,
                {
                    name: name,
                    column_id: columnId,
                    ...({ description: params.description } || {})
                },
                {
                    cancelToken: new CancelToken(c => {
                        cancelCreateSiteCardFromFeatureAnalysis = c;
                    })
                }
            );
            dispatch(createSiteCardSuccess(response.data));
            dispatch(openSnackbar('success', 'Successfully created site card'));
        } catch (error) {
            console.error(error);
            // Redirect to the sites page if there is a 404 error
            dispatch(createSiteCardError(error.response));
        }
    };
};

// Create sitecard from feature analysis
export const createSiteCardsFromFeatureAnalysesAsync = (
    featureAnalysisIds: number[],
    columnId: number
) => {
    cancelCreateSiteCardsFromFeatureAnalyses && cancelCreateSiteCardsFromFeatureAnalyses();
    return async (dispatch: Dispatch) => {
        dispatch(createSiteCards());
        try {
            const response = await axios.put(
                '/api/feature_analyses/site_card',
                {
                    ids: featureAnalysisIds,
                    column_id: columnId
                },
                {
                    cancelToken: new CancelToken(c => {
                        cancelCreateSiteCardsFromFeatureAnalyses = c;
                    })
                }
            );
            dispatch(createSiteCardsSuccess(response.data));
            dispatch(openSnackbar('success', 'Successfully created site cards'));
        } catch (error) {
            // Redirect to the sites page if there is a 404 error
            console.error(error);
            dispatch(openSnackbar('error', 'Error creating site card'));
            dispatch(createSiteCardsError(error.response));
        }
    };
};

export const updateSiteCardAsync = (id: number, form: any) => {
    cancelUpdateSiteCard && cancelUpdateSiteCard();
    return async (dispatch: Dispatch) => {
        dispatch(updateSiteCard(id));
        try {
            const response = await axios.patch(
                `/api/site_cards/${id}`,
                {
                    ...(form.name !== undefined ? { name: form.name } : {}),
                    ...(form.description !== undefined ? { description: form.description } : {})
                },
                {
                    cancelToken: new CancelToken(c => {
                        cancelUpdateSiteCard = c;
                    })
                }
            );
            dispatch(updateSiteCardSuccess(id, response.data));
            dispatch(openSnackbar('success', 'Successfully updated site card'));
        } catch (error) {
            console.error(error);
            dispatch(openSnackbar('error', 'Error updating site card'));
            dispatch(updateSiteCardError(error.response));
        }
    };
};

export const deleteSiteCardAsync = (id: number) => {
    cancelDeleteSiteCard && cancelDeleteSiteCard();
    return async (dispatch: Dispatch) => {
        dispatch(deleteSiteCard(id));
        try {
            await axios.delete(`/api/site_cards/${id}`, {
                cancelToken: new CancelToken(c => {
                    cancelDeleteSiteCard = c;
                })
            });
            dispatch(deleteSiteCardSuccess(id));
            dispatch(openSnackbar('success', 'Successfully deleted site card'));
        } catch (error) {
            console.error(error);
            dispatch(openSnackbar('error', 'Error deleting site card'));
            dispatch(deleteSiteCardError(error.response));
        }
    };
};

export function isFetching(siteCard: SiteCard) {
    return Boolean(
        siteCard.isFetchingSiteCard ||
            siteCard.isFetchingAnalysis ||
            siteCard.isFetchingAreaInfo ||
            siteCard.isFetchingNearby ||
            siteCard.isFetchingOwnership ||
            siteCard.isFetchingPlanningApplications ||
            siteCard.isFetchingValueInfo
    );
}

const fileExtensions = {
    csv: 'csv',
    geojson: 'geojson',
    shapefile: 'zip',
    geopackage: 'gpkg',
    geodatabase: 'zip',
    kml: 'kml'
};

const mimeTypes: { [key: string]: string } = {
    csv: 'text/csv',
    geojson: 'application/json',
    kml: 'application/vnd.google-earth.kml+xml',
    geopackage: 'application/octet-stream',
    shapefile: 'application/zip',
    geodatabase: 'application/zip'
};

export function exportSiteCardAsync(
    cardId: number,
    fields: string[],
    fileName: string,
    fileFormat: keyof typeof fileExtensions,
    targetCrs: string
): any {
    return (dispatch: Dispatch): any => {
        dispatch(exportSiteCardRequest());
        let responseType;
        switch (fileFormat) {
            case 'csv':
                responseType = 'blob';
                break;
            case 'geojson':
            case 'shapefile':
            case 'geopackage':
            case 'geodatabase':
            case 'kml':
                responseType = 'arraybuffer';
                break;
            default:
                responseType = 'json';
        }

        axios
            .post(
                `/api/site_cards/${cardId}/export`,
                {
                    fields,
                    file_format: fileFormat,
                    file_name: snakeCase(fileName),
                    target_crs: targetCrs
                },
                { responseType: responseType }
            )
            .then(response => {
                const filename = `${fileName}.${fileExtensions[fileFormat]}`;

                // Validate and get the MIME type for the file format
                const mimeType = mimeTypes[fileFormat];
                if (!mimeType) {
                    console.error(`Unsupported file format: ${fileFormat}`);
                    return;
                }

                // Create the Blob with the determined MIME type
                const blob = new Blob([response.data], { type: mimeType });

                // General download logic
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                link.remove(); // Clean up
                dispatch(exportSiteCardSucess());
            })
            .catch(errr => {
                dispatch(exportSiteCardError(errr));
            });
    };
}
